import { Subject } from 'rxjs';
import { WorkflowConfig } from '../../../../tamalelibs/models/workflow.model';
import { WorkflowDialogOperations } from '../../workflow-model';

export enum WorkflowEditorSubChromeActionType {
    onSave,
    resetPage,
    onSaveAsDraft,
    onClickDraftLink,
    syncNodes
}

export enum WorkflowEditorSubChromeEventType {
    setLoading,
    draftLinkStatus
}

export class WorkflowEditorSubChromeConfig {
    config: WorkflowConfig;
    changeRouterBySelf: boolean;
    changeRouterBySelfDialog: boolean;
    opType: string;
    actions$: Subject<{ type: WorkflowEditorSubChromeActionType, payload?: any }>;
    events$: Subject<{ type: WorkflowEditorSubChromeEventType, payload?: any }>;
    constructor() {
        this.config = new WorkflowConfig();
        this.changeRouterBySelf = false;
        this.changeRouterBySelfDialog = false;
        this.actions$ = new Subject();
        this.events$ = new Subject();
        this.opType = WorkflowDialogOperations.NEW;
    }
}
